import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { SignalCellularFullIcon } from '@moia-dev/pace-icons'
import { SimManagementAreaRoutes } from './SimManagementAreaRoutes'

export const SimManagementAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={SimManagementAreaRoutes.route}
      Icon={SignalCellularFullIcon}
    />
  )
}
